module.exports = __webpack_public_path__ + "img/china-petroleum-logo.0663e53a.png";